<template>
    <div>
        <v-container fluid :style="{ 'min-height': '800px' }">
            <v-container class="contain-width">
                <v-row>
                    <v-col
                            cols="12"
                            md="8"
                            offset-md="2"
                    >
                        <h1 class="mt-6 mb-6">{{ $t('headings.Individuals') }}</h1>
                        <v-card
                                class="mx-auto info-card"
                                outlined
                        >
                            <v-card-title class="headline primary--text">{{ $t("Let's get your lost kit back") }}</v-card-title>

                            <vimeo-player ref="player" video-id="395463151" @ready="onReady" class="player-container" :options="options">
                            </vimeo-player>

                            <v-card-text class="text--primary">

                                <h2 class="text-h6 mb-4" v-if="organisation">{{ $t('You have been invited to join findmykit by {organisation}', {organisation: organisation.name}) }}</h2>

                                <p>{{ $t("Sign up as an individual if you wish to buy tags for yourself, friends, family, dependants and anyone we have not mentioned!") }}</p>

                                <IndividualsSummary />

                                <IndividualsContent />
                            </v-card-text>

                            <v-card-actions>
                                <v-btn rounded elevation="0" color="primary" @click="navigate('sign-up-individual')">
                                    <span v-if="organisation">{{ $t('buttons.Sign up to') }} {{ organisation.name }}</span>
                                    <span v-else>{{ $t('buttons.Sign up as individual') }}</span>
                                </v-btn>
                            </v-card-actions>

                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import Footer from './Footer.vue'
    import { mapActions, mapState } from 'vuex'
    import axios from 'axios';
    import IndividualsSummary from "./IndividualsSummary";
    import IndividualsContent from "./IndividualsContent"
    import {i18n} from "../i18n";

    export default {
        name: "Individuals",
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Individuals'),
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'description', content: i18n.t('Sign up as an individual if you wish to buy tags for yourself, friends, family, dependants and anyone we have not mentioned!') }
            ]
          }
        },
        components: {
          'Footer': Footer,
          IndividualsSummary,
          IndividualsContent
        },
        data () {
            return {
                options: {'responsive': true, 'dnt': true},
                playerReady: false,
                organisation: null
            }
        },
        mounted () {

            window.scrollTo(0,0);

            window.prerenderReady = true;

            if (this.$router.currentRoute.query.organisation) {
                this.referringOrganisation(this.$router.currentRoute.query.organisation).then(() => {
                    console.log(this.$router.currentRoute.query.organisation)

                    const instance = axios.create({
                        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                    });

                    instance
                        .get('/api/organisations/enabled?brand=' + this.brand)
                        .then(response => {
                            if (response.status === 200) {
                                let activeOrganisations = response.data.data

                                for (let x in activeOrganisations) {
                                    if (activeOrganisations[x].slug && this.organisationSlug && activeOrganisations[x].slug === this.organisationSlug) {
                                        this.organisation = activeOrganisations[x]
                                    }
                                }
                            }
                        })
                        .catch(error => {
                            console.log(error)
                        })
                        .finally(() => {
                            this.show = true
                            window.prerenderReady = true;
                        })
                })
            }
            else {
              this.referringOrganisation(null).then(() => {
                this.organisation = null;
              })
            }
        },
        methods: {
            ...mapActions(['referringOrganisation']),
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            navigate(routeName) {
                this.$router.push({name: routeName})
            },
            onReady() {
                this.playerReady = true
            },
            play () {
                this.$refs.player.play()
            },
            stop () {
                this.$refs.player.stop()
            },
        },
        computed: {
            ...mapState({
                organisationSlug: state => state.referringOrganisation,
                brand: state => state.brand,
                brandName: state => state.brandName
            }),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
        }
    }
</script>

<style scoped>
    .v-card__actions {
        padding: 16px;
        justify-content: flex-end;
    }
    .info-card {
        border-radius: 15px;
        border: none !important;
    }
</style>
